module.exports = __webpack_public_path__ + "static/media/icon-filter-options-black.079323f2.svg";